import type React from 'react';
import type { JSX } from 'react';

import SvgIcon from '@mui/material/SvgIcon';

interface Props {
    color?: string;
    opacity?: string;
    fillOpacity?: string;
    size?: number;
    props?: React.ComponentProps<typeof SvgIcon>;
}

export const CustomSportsHockey = ({
    color,
    opacity = '1',
    fillOpacity = '1',
    size = 20,
    props,
}: Props): JSX.Element => (
    <SvgIcon style={{ width: size, height: size }} {...props} viewBox="0 0 20 20">
        <path
            d="M1.66669 16.6668V14.1668C1.66669 13.9307 1.74655 13.7328 1.90627 13.5731C2.06599 13.4134 2.26391 13.3335 2.50002 13.3335H3.33335V16.6668H1.66669ZM4.16669 16.6668V13.3335H7.50002L8.20835 11.7085L9.54169 14.6252L8.83335 16.2085C8.76391 16.3613 8.65974 16.4759 8.52085 16.5522C8.38197 16.6286 8.23613 16.6668 8.08335 16.6668H4.16669ZM16.6667 16.6668V13.3335H17.5C17.7361 13.3335 17.934 13.4134 18.0938 13.5731C18.2535 13.7328 18.3334 13.9307 18.3334 14.1668V16.6668H16.6667ZM15.8334 16.6668H11.9167C11.7639 16.6668 11.6181 16.6286 11.4792 16.5522C11.3403 16.4759 11.2361 16.3613 11.1667 16.2085L5.29169 3.3335H8.08335L10 7.66683L11.9167 3.3335H14.7084L11.3334 10.7085L12.5 13.3335H15.8334V16.6668Z"
            fill={color}
            opacity={opacity}
            fillOpacity={fillOpacity}
        />
    </SvgIcon>
);
